import React from 'react'
import FavoriteActivitiesFilterProTracks from '../FavoriteActivitiesFilterProTracks'

const FavoriteActivitiesFilters = () => (
  <div className="favorite-activities-filters">
    <FavoriteActivitiesFilterProTracks />
  </div>
)

export default FavoriteActivitiesFilters
